import { defineMessages } from 'react-intl';

export default defineMessages({
    makeChanges: {
        id: 'ml.policychange.vehicles.Make Changes',
        defaultMessage: 'Make Changes'
    },
    missingFields:{
        id:'ml.policychange.vehicles.Please complete all required fields',
        defaultMessage:'Please complete all required fields'
    },
    trailerCannotBeTheOnlyVehicle:{
        id:'ml.policychange.vehicles.A trailer cannot be the only vehicle on the policy',
        defaultMessage:'A trailer cannot be the only vehicle on the policy.'
    },
    duplicateVinForVehicle:{
        id:'ml.policychange.vehicles.This VIN number has already been listed for another vehicle.',
        defaultMessage:'This VIN has already been listed for another vehicle.'
    },
    nonOwnedSelectedError:{
        id:"ml.policychange.vehicles.We're sorry, we are unable to complete your quote on line at this time due to the non-owned vehicle.  You can contact customer service by chat or call us at 1-888-332-0460.  When contacting us, please include your quote number.",
        defaultMessage:"We're sorry, we are unable to complete your quote on line at this time due to the non-owned vehicle.  You can contact customer service by chat or call us at 1-888-332-0460.  When contacting us, please include your quote number."
    },
    noVehiclesForCommuteOrBussinessError:{
        id:"ml.policychange.vehicles.One or more drivers are listed as employed and no vehicles are listed as commute to work or business use. Please review and update if needed.",
        defaultMessage:"One or more drivers are listed as employed and no vehicles are listed as commute to work or business use. Please review and update if needed."
    },
    noVehiclesForBusinessError: {
        id: 'ml.policychange.vehicles.missingBusinessUseError',
        defaultMessage: 'One or more drivers are listed as employed and no vehicles are listed as business use. Please review and update if needed.'
    },
    save:{
        id:'ml.policychange.vehicles.save...',
        defaultMessage:'Save...'
    },
    saveEndorsement:{
        id:'ml.policychange.vehicles.Saving endorsement...',
        defaultMessage:'Saving endorsement...'
    },
    addVehicle:{
        id:'ml.policychange.vehicles.Add Vehicle',
        defaultMessage:'Add Vehicle'
    },
    addNewVehicleDetails:{
        id:'ml.policychange.vehicles.Please add the details for your new vehicle below',
        defaultMessage:'Please add the details for your new vehicle below'
    },
    updateVehicleDetails:{
        id:'ml.policychange.vehicles.Please update the details for this vehicle below',
        defaultMessage:'Please update the details for this vehicle below'
    },
    replaceVehicle:{
        id:'ml.policychange.vehicles.Replace Vehicle',
        defaultMessage:'Replace Vehicle'
    },
    editVehicle:{
        id:'ml.policychange.vehicles.edit Vehicle',
        defaultMessage:'Edit Vehicle'
    },
    additionalChanges:{
        id:'ml.policychange.vehicles.We will check if additional change are needed next',
        defaultMessage:'We\'ll check if <strong>additional change are needed</strong> next'
    },
    reviewCoverages:{
        id:'ml.policychange.vehicles.We will review your coverages next',
        defaultMessage:'We\'ll review <strong>your coverages</strong> next'
    },
    vehicleReplaced:{
        id:'ml.policychange.vehicles.Vehicle Replace Message',
        defaultMessage:' {strongName} will be removed from the policy. Please add the replacement vehicle below.'
    },
    Edit:{
        id:'ml.policychange.vehicles.Edit',
        defaultMessage:'Edit'
    },
    vin:{
        id:'ml.policychange.vehicles.VIN # x',
        defaultMessage:'VIN # {number}'
    },
    EditVehicle:{
        id:'ml.policychange.vehicles.Edit vehicle',
        defaultMessage:'Edit vehicle'
    },
    subtitle:{
        id:'ml.policychange.vehicles.Update your vehicle information below',
        defaultMessage:'Update your vehicle information below'
    },
    syncing:{
        id:'ml.policychange.vehicles.Syncing',
        defaultMessage:'Syncing...'
    },
    ampSubheaderAdd:{
        id:'ml.policychange.vehicles.Please add the details for your new vehicle below',
        defaultMessage:'Please add the details for your new vehicle below'
    },
    ampSubheaderEdit:{
        id:'ml.policychange.vehicles.Please update the details for this vehicle below',
        defaultMessage:'Please update the details for this vehicle below'
    },
    vehicles:{
        id:'ml.policychange.vehicles.Vehicles',
        defaultMessage:'Vehicles'
    },
    vehicleUseStorageError : {
        id: "ml.policychange.vehicles.vehicleUseStorageError",
        defaultMessage: "A policy cannot have all vehicles primarily used for storage. Please update the usage for one of the vehicles."
    },
    vinInvalidCharactersError: {
        id: 'ml.policychange.vehicles.vinInvalidCharactersError',
        defaultMessage: "Correct the VIN. The characters 'I', 'O', and 'Q' are not allowed in any position for vehicles with model year 1981 or later."
    },
    vinNinthCharacterError: {
        id: 'ml.policychange.vehicles.vinNinthCharacterError',
        defaultMessage: "Correct the VIN. The 9th character must be a number from 0 to 9 or the letter X for vehicles with model year 1981 or later."
    },
    vinTenthCharacterError: {
        id: 'ml.policychange.vehicles.vinTenthCharacterError',
        defaultMessage: "Correct VIN for Vehicle. The 10th character cannot be 'U', 'Z', or the number 0 for vehicles with model year 1981 or later."
    },
    vehiclePurchaseDateError: {
        id: 'ml.policychange.vehicles.vehiclePurchaseDateError',
        defaultMessage: "Change the purchase date for vehicle {year} {make} {model}. Purchase date must be on or before the effective date."
    },
     vehiclePurchaseDateErrorForTrailerAndCamper: {
        id: 'ml.policychange.vehicles.vehiclePurchaseDateErrorForTrailerAndCamper',
        defaultMessage: "Change the purchase date for camper/trailer. Purchase date must be on or before the effective date."
    }

})